import { Component } from 'preact';
import PropTypes from 'prop-types';

// Components
import InputText from './InputText';
import { replaceData } from '../../../utilities/common';

class Text extends Component {
  render() {
    const newProps = this.props;
    newProps.updateValue = (value, values) => {
      if (value) {
        // This is fix if the next step is a text component (like previous step) as well
        // the id won't get updated. (so add a value to fix this)
        return replaceData(value, values, false, false, false, true);
      }
      return value;
    };

    return (
      <InputText
        {...newProps}
      />
    );
  }
}

export default Text;

Text.defaultProps = {
  required: false,
  placeholder: null,
  desc: null,
  label: null,
  maxLength: null,
  endFocus: null,
  mobileColumns: null,
  formValues: [],
  formValuesTemplate: '',
  actions: [],
  tealiumMap: null,
  loadingOnField: '',
  value: null,
  genetiveCase: false,
  variant: '',
  labelActions: null,
  disabled: false,
  autoComplete: 'on',
  actionVariant: '',
  actionEnterEnabled: true,
};

Text.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  formValues: PropTypes.array,
  formValuesTemplate: PropTypes.string,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  columns: PropTypes.string.isRequired,
  mobileColumns: PropTypes.string,
  label: PropTypes.string,
  desc: PropTypes.string,
  maxLength: PropTypes.number,
  endFocus: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  labelActions: PropTypes.object,
  values: PropTypes.object.isRequired,
  actions: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  tealiumMap: PropTypes.string,
  translations: PropTypes.object,
  loadingOnField: PropTypes.string,
  userData: PropTypes.object.isRequired,
  value: PropTypes.string,
  genetiveCase: PropTypes.bool,
  disabled: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  variant: PropTypes.string,
  autoComplete: PropTypes.string,
  actionVariant: PropTypes.string,
  actionEnterEnabled: PropTypes.bool,
};
